import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { defaultSize, rotationEnum, sizePropsTypes } from './icons.constants';

const ArrowIcon = ({ size = defaultSize, direction = IconDirection.DOWN, className, ...props }) => (
  <svg
    className={clsx(rotationEnum[direction], className)}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 2C12.5523 2 13 2.44772 13 3V18.5858L15.2929 16.2929C15.6834 15.9024 16.3166 15.9024 16.7071 16.2929C17.0976 16.6834 17.0976 17.3166 16.7071 17.7071L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L7.29289 17.7071C6.90237 17.3166 6.90237 16.6834 7.29289 16.2929C7.68342 15.9024 8.31658 15.9024 8.70711 16.2929L11 18.5858V3C11 2.44772 11.4477 2 12 2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ArrowIcon.propTypes = {
  ...sizePropsTypes,
  direction: PropTypes.oneOf(Object.keys(rotationEnum)),
  className: PropTypes.string,
};

export default memo(ArrowIcon);
